import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import { BsArrowCounterclockwise } from "react-icons/bs";

import auth from "../services/authService";
import { getStatus } from "../services/statusService";

const user = auth.getCurrentUser(); // 1. Is there a token in the storage?

const CodigoQR = () => {

  let qrcode = '';
  
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [nome, setNome] = useState('');
  const [validade, setValidade] = useState('');
  const [ativo, setAtivo] = useState(0);

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {

    setIsLoading(true);

    getStatus()
      .then((response) => {
        console.log("QRCode", response.data.msg);
        setNome(response.data.msg.nome);
        setValidade(response.data.msg.data_validade);
        setAtivo(response.data.msg.ativo);

        setIsLoading(false);
    })
      .catch((err) => {
        setIsLoading(false);
    });

    /* QRCode.toDataURL("1000", {width: 300}, (err, codigo) => {
      setQrcode(codigo);
    }) */

    if (user) {
      //2023-02-21
      //QRCode.toCanvas(document.getElementById('canvas'), user.email, {width: 200}, (error) => {
      QRCode.toCanvas(document.getElementById('canvas'), "QR" + String(user.email).padStart(8, '0'), {width: 200}, (error) => {
      if (error) return console.error(error)
        console.log('success! ', user.email);}) 
      }

  }, [refresh]);
  
  return (
    <>
      <div
        style={{
          height: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {qrcode && <img style={{ width: "100%" }} src={qrcode} alt="" />}
        <canvas id="canvas"></canvas>
      </div>
      <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{nome}</p>
      {/*<p style={{ fontSize: "1.2rem" }}>
        (Válido até <span style={{ fontWeight: "bold" }}>{validade}</span>)
      </p>*/}
      {validade === "" ? (
        <p>
          ( <span style={{ fontWeight: "bold", color: "red" }}>INATIVO </span> )
        </p>
      ) : ativo === 1 ? (
        <p style={{ fontSize: "1.2rem" }}>
          (Ativo até{" "}
          <span style={{ fontWeight: "bold", color: "green" }}>{validade}</span>
          )
        </p>
      ) : (
        <p style={{ fontSize: "1.2rem" }}>
          (Inativo desde{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>{validade}</span>)
        </p>
      )}
      {/*<div
        onClick={() => {
          setRefresh((r) => !r);
        }}
      >
        <BsArrowCounterclockwise
          style={{ cursor: "pointer", fontSize: "2rem", fontWeight: "bold" }}
        />
      </div>*/}
      <button
        onClick={() => {
          setRefresh((r) => !r);
        }}
      >
        Atualizar
      </button>
    </>
  );
}
 
export default CodigoQR;
